import React, { useState } from "react";
import { fade, makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import ButtonBase from "@material-ui/core/ButtonBase";
import Badge from "@material-ui/core/Badge";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Popper from "@material-ui/core/Popper";
import Fade from "@material-ui/core/Fade";

import { redirect } from "redux-first-router";
import config from "../lib/config";

const useStyles = makeStyles((theme) => ({
  navBar: {
    position: "relative",
    display: "flex",
    overflow: "auto",
    margin: theme.spacing(0, 4),
  },
  navBarItem: {
    borderColor: fade(theme.palette.common.white, 0.25),
    borderRightWidth: "thin",
    borderRightStyle: "solid",
    "&:first-child": {
      borderLeftWidth: "thin",
      borderLeftStyle: "solid",
    },
  },
  navBarButton: {
    minWidth: "150px",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    position: "relative",
    padding: theme.spacing(2, 0),
    cursor: "pointer",
    textDecoration: "none",
    transition: "0.2s ease-out",
    "&:after": {
      content: '""',
      display: "block",
      position: "absolute",
      bottom: 0,
      left: 0,
      width: `100%`,
      height: 3,
      transform: "scale(0, 1)",
      transition: "0.2s ease-out",
      opacity: 0,
      backgroundColor: theme.palette.primary.light,
    },
    outline: "unset",
    "&:hover, &$focusVisible": {
      outline: "unset",
      backgroundColor: fade(theme.palette.common.white, 0.15),
      "&:after": {
        opacity: 1,
        transform: "scale(1, 1)",
      },
    },
  },
  itemText: {
    margin: theme.spacing(0.5, 1),
  },
  focusVisible: {},
  itemActive: {
    "&$item": {
      color:
        theme.palette.type === "dark"
          ? theme.palette.primary.light
          : theme.palette.primary.main,
      "&:after": {
        opacity: 1,
        transform: "scale(1, 1)",
        backgroundColor:
          theme.palette.type === "dark"
            ? theme.palette.primary.light
            : theme.palette.primary.main,
      },
    },
  },
  menuList: {
    zIndex: theme.zIndex.modal,
  },
  navLink: {},
  paper: {
    marginTop: theme.spacing(0),
    backgroundColor: theme.palette.background.default,
    boxShadow: theme.shadows[4],
    minWidth: "150px",
  },
}));

const TopbarView = (props) => {
  const classes = useStyles();
  const { menuItems = [] } = config;
  const [anchorEl, setAnchorEl] = useState();
  const [open, setOpen] = useState();

  const handleMenuNavigate = (menuType, childMenuType) => {
    props.dispatch(
      redirect({
        type: "PAGE",
        payload: {
          orgId: props.orgId,
          toplevel: menuType,
          secondlevel: childMenuType,
        },
      })
    );
  };

  const handleMenuFocus = (event, idx) => {
    setOpen(idx);
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleMenuBlur = (event) => {
    event.currentTarget.blur();
    setOpen(null);
    setAnchorEl(null);
  };

  return (
    <div className={classes.navBar}>
      {menuItems.map((menuItem, idx) => (
        <div className={classes.navBarItem} key={menuItem.title}>
          <ButtonBase
            className={classes.navBarButton}
            focusRipple
            focusVisibleClassName={classes.focusVisible}
            onFocus={(event) => handleMenuFocus(event, idx)}
            onBlur={handleMenuBlur}
            color="inherit"
          >
            <Badge badgeContent={menuItem.badge} color="primary">
              <Typography variant="button" className={classes.itemText}>
                {menuItem.title}
              </Typography>
            </Badge>
          </ButtonBase>
          <Popper
            className={classes.menuList}
            open={open === idx}
            anchorEl={anchorEl}
            transition
            placement="bottom-start"
          >
            {({ TransitionProps }) => (
              <Fade {...TransitionProps} timeout={350}>
                <div className={classes.paper}>
                  {menuItem.children.map((childMenuItem) => (
                    <List
                      component="div"
                      disablePadding
                      key={childMenuItem.title}
                    >
                      <ListItem
                        button
                        onClick={() =>
                          handleMenuNavigate(menuItem.type, childMenuItem.type)
                        }
                        className={classes.navLink}
                      >
                        <Badge
                          badgeContent={childMenuItem.badge}
                          color="primary"
                        >
                          <ListItemText primary={childMenuItem.title} />
                        </Badge>
                      </ListItem>
                    </List>
                  ))}
                </div>
              </Fade>
            )}
          </Popper>
        </div>
      ))}
    </div>
  );
};

export default TopbarView;
